var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from 'react';
import { useService } from '@tenderd/track-web-utils';
import { useAuth } from '@tenderd/track-web-utils';
import { useGroupService } from './GroupServiceProvider';
var Context = React.createContext(null);
export var useOperatorService = function () {
    return React.useContext(Context);
};
export var OperatorServiceProvider = function (props) {
    var _a = __read(useState({}), 2), operators = _a[0], setOperators = _a[1];
    var _b = __read(useState(false), 1), loading = _b[0];
    var service = useService();
    var _c = useAuth(), user = _c.user, account = _c.account;
    var groupService = useGroupService();
    var load = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (!groupService.group)
                return [2 /*return*/];
            if (Object.keys(operators).length > 0)
                return [2 /*return*/];
            if (groupService.group.doc.internal.enterprise_master_group) {
                return [2 /*return*/, service.server
                        .getOperatorsUnderAccount(groupService.group.doc.account_ref.id)
                        .then(function (docs) {
                        var map = {};
                        docs.map(function (d) { return (map[d.id] = d); });
                        setOperators(map);
                    })];
            }
            else {
                return [2 /*return*/, service.server
                        .getOperatorsUnderAccount(account.id)
                        .then(function (docs) {
                        var map = {};
                        docs.map(function (d) { return (map[d.id] = d); });
                        setOperators(map);
                    })];
            }
            return [2 /*return*/];
        });
    }); };
    var add = function (form) { return __awaiter(void 0, void 0, void 0, function () {
        var operator;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!groupService.group || !groupService.group.doc.account_ref)
                        return [2 /*return*/];
                    operator = {
                        account_ref: groupService.group.doc.account_ref,
                        name: form.name,
                        mobile_number: form.mobile,
                        custom_id: form.customId,
                        ibutton: form.iButton,
                        remarks: form.remarks,
                        internal: {
                            created_at: new Date(),
                            created_by_ref: {
                                id: user.id,
                                label: user.doc.name,
                            },
                            last_updated_at: new Date(),
                        },
                    };
                    return [4 /*yield*/, service.server.addOperator(operator).then(function (v) { return __awaiter(void 0, void 0, void 0, function () {
                            var _a;
                            return __generator(this, function (_b) {
                                setOperators(__assign((_a = {}, _a[v.id] = { id: v.id, doc: operator }, _a), operators));
                                return [2 /*return*/];
                            });
                        }); })];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); };
    var update = function (id, form) { return __awaiter(void 0, void 0, void 0, function () {
        var currentOperator, operator;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!groupService.group || !groupService.group.doc.account_ref)
                        return [2 /*return*/];
                    return [4 /*yield*/, service.server.getOperator(id)];
                case 1:
                    currentOperator = _a.sent();
                    operator = {
                        name: form.name,
                        mobile_number: form.mobile,
                        internal: {
                            last_updated_at: new Date(),
                            created_at: currentOperator.doc.internal.created_at,
                            created_by_ref: currentOperator.doc.internal.created_by_ref,
                        },
                    };
                    if (form.ibutton) {
                        operator.ibutton = form.ibutton;
                    }
                    if (form.remarks) {
                        operator.remarks = form.remarks;
                    }
                    if (form.custom_id) {
                        operator.custom_id = form.custom_id;
                    }
                    return [4 /*yield*/, service.server.updateOperator(id, operator).then(function (v) { return __awaiter(void 0, void 0, void 0, function () {
                            var _a;
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        setOperators(__assign(__assign({}, operators), (_a = {}, _a[id] = { id: id, doc: __assign(__assign({}, operators[id].doc), operator) }, _a)));
                                        if (!operator.ibutton) return [3 /*break*/, 2];
                                        return [4 /*yield*/, service.telematics.updateIButtonByOperatorId({
                                                operator_ref: {
                                                    id: id,
                                                    label: form.name,
                                                },
                                                ibutton: operator.ibutton,
                                            })];
                                    case 1:
                                        _b.sent();
                                        _b.label = 2;
                                    case 2: return [2 /*return*/];
                                }
                            });
                        }); })];
                case 2:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var remove = function (id) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, service.server.deleteOperator(id).then(function () { return __awaiter(void 0, void 0, void 0, function () {
                    var _a;
                    return __generator(this, function (_b) {
                        setOperators(__assign(__assign({}, operators), (_a = {}, _a[id] = undefined, _a)));
                        return [2 /*return*/];
                    });
                }); })];
        });
    }); };
    var gService = {
        load: load,
        add: add,
        update: update,
        remove: remove,
        operators: operators,
        loading: loading,
    };
    return (React.createElement(Context.Provider, { value: gService }, props.children));
};
